/**
 * Calculates cartesian product of multiple arrays
 *
 * @param args Arrays to calculate cartesian product of e.g [[1,2], [3,4]]
 * @returns cartesian product of arrays e.g [[1,3], [1,4], [2,3], [2,4]]
 */
export const cartesianProduct = (...args: any[]) => {
  const r: any[] = [];
  const max = args.length - 1;

  function _cartesian(arr: any[], i: number) {
    for (let j = 0, l = args[i].length; j < l; j++) {
      const a = [...arr]; // clone arr
      a.push(args[i][j]);

      if (i == max) {
        r.push(a);
      } else {
        _cartesian(a, i + 1);
      }
    }
  }

  _cartesian([], 0);
  return r;
};
